import * as React from 'react';
import {Trans} from '@lingui/react';
import {useLocation} from 'react-router-dom';
import cl from 'classnames';

import SkillupLogo from '@components/Icons/SkillupLogo';

import {getSuffix} from '@services/utilities';

import s from './ErrorPage.css';

export default function ErrorPage() {
  const {search} = useLocation();

  const code = React.useMemo(() => {
    const searchParams = new URLSearchParams(search);
    return searchParams.get('code');
  }, [search]);

  return (
    <div className={cl(s.LoginPage)}>
      <SkillupLogo className={s.Logo} negative size="38px" />

      <p className={s.Welcome}>
        {code === 'NO_SSO' ? (
          <Trans id="sso_error.no_sso">L'azienda non risulta avere un servizio di SSO attivo</Trans>
        ) : code === 'NO_ACTIVE_CAMPAIGN' ? (
          <Trans id="sso_error.no_active_campaign">Non c'è nessuna campagna valida</Trans>
        ) : code === 'USER_NOT_FOUND' ? (
          <Trans id="sso_error.user_not_found">Utente non trovato</Trans>
        ) : (
          <Trans id="sso_error.general">Oops c'è stato un errore in fase di login</Trans>
        )}
        <br />
      </p>
      <p className={s.Copyright}>{`Skillup © ${new Date().getFullYear()} ${getSuffix()}`}</p>
    </div>
  );
}
